// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {

      //**-* EXW PERASEI APO EDW!!!
      //console.log("HandleLogin state & action (authenctication.js) : ", state, action)

      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem('accessToken', action.payload.accessToken)
      localStorage.setItem('calendarChanges', JSON.stringify([]))
      localStorage.setItem('calendarView', 'resourceTimelineWeek')

      ////Old local storage values from the original project
      //localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
      //localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
   

      //#region ** Select the first company and first application of the user by default after login. This logic is stopped after the creation of 'AfterLogin' view! **
        ////Check if user has any companies deligated to him.
        // if (state.userData.companies.length > 0) {
        //   localStorage.setItem('selectedHotel', JSON.stringify(state.userData.companies[0]))

        //   //Check if user's first company has any apps.
        //   if (state.userData.companies[0].apps.length > 0) {
        //     localStorage.setItem('selectedApp', JSON.stringify(state.userData.companies[0].apps[0]))
        //   } else {
        //     localStorage.setItem('selectedApp', JSON.stringify({ApplicationName: 'NoApps'}))
        //   }
        // } else {
        //   localStorage.setItem('selectedApp', JSON.stringify({ApplicationName: 'NoApps'}))
        // }
      //#endregion
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('selectedHotel')
      localStorage.removeItem('selectedApp')
      localStorage.removeItem('calendarChanges')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('currentPage')
      localStorage.removeItem('paginationPerPage')
      //Clear all localstorage values
      localStorage.clear()

      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)
      //window.location.href = "/login"
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
